/* REAVERFIT — Swatches click-only behaviour (no hover preview) */
console.log('REAVERFIT: Script chargé');

(function () {
  function closestCard(el) {
    // Chercher la vraie carte produit, pas juste le conteneur des pastilles
    let card = el.closest('product-card');
    if (!card) {
      card = el.closest('.product-card');
    }
    if (!card) {
      card = el.closest('.grid__item');
    }
    if (!card) {
      // En dernier recours, remonter jusqu'à trouver un élément qui contient des images
      let parent = el.parentElement;
      while (parent && parent !== document) {
        if (parent.querySelector('img') && parent.querySelector('.product-card__media, .product-card__figure')) {
          card = parent;
          break;
        }
        parent = parent.parentElement;
      }
    }
    
    console.log('REAVERFIT: Carte trouvée:', card);
    console.log('REAVERFIT: Type de carte:', card ? card.tagName + '.' + card.className : 'null');
    
    return card || document;
  }

  function setActive(link) {
    const wrap = link.closest('.card-color-swatches');
    if (!wrap) return;
    wrap.querySelectorAll('.card-color-swatch__link.active').forEach(a => {
      a.classList.remove('active');
      a.setAttribute('aria-pressed','false');
    });
    link.classList.add('active');
    link.setAttribute('aria-pressed','true');
  }

  // Cherche une image "principale" et une "hover" sans casser le thème
  function findImages(card) {
    console.log('REAVERFIT: Recherche d\'images dans la carte:', card);
    console.log('REAVERFIT: Structure de la carte:', card.innerHTML.substring(0, 500));
    
    // principale - essayer tous les sélecteurs possibles
    let mainImg = null;
    const mainSelectors = [
      '.product-card__image--primary',
      '.product-card__media img',
      '.product-card__figure img',
      'product-card img',
      'img'
    ];
    
    for (const selector of mainSelectors) {
      mainImg = card.querySelector(selector);
      if (mainImg) {
        console.log('REAVERFIT: Image principale trouvée avec sélecteur:', selector, mainImg);
        break;
      }
    }

    // hover (deuxième image courante) - adapter au thème actuel
    let hoverImg = card.querySelector('.product-card__image--secondary');
    
    // Si pas trouvé, créer l'image secondaire dynamiquement
    if (!hoverImg && mainImg) {
      const mediaContainer = card.querySelector('.product-card__media') || card.querySelector('.product-card__figure') || mainImg.parentElement;
      if (mediaContainer) {
        hoverImg = document.createElement('img');
        hoverImg.className = 'product-card__image product-card__image--secondary';
        hoverImg.loading = 'lazy';
        hoverImg.draggable = false;
        hoverImg.style.position = 'absolute';
        hoverImg.style.top = '0';
        hoverImg.style.left = '0';
        hoverImg.style.width = '100%';
        hoverImg.style.height = '100%';
        hoverImg.style.opacity = '0';
        hoverImg.style.objectFit = 'cover';
        mediaContainer.appendChild(hoverImg);
        console.log('REAVERFIT: Image secondaire créée dynamiquement dans:', mediaContainer);
      }
    }

    console.log('REAVERFIT: Images trouvées - mainImg:', !!mainImg, 'hoverImg:', !!hoverImg);
    if (mainImg) console.log('REAVERFIT: mainImg element:', mainImg);
    if (hoverImg) console.log('REAVERFIT: hoverImg element:', hoverImg);

    return { mainImg, hoverImg };
  }

  // Click uniquement - mise à jour de l'image pour montrer le produit lié
  document.addEventListener('click', (e) => {
    console.log('REAVERFIT: Clic détecté sur:', e.target);
    
    const sw = e.target.closest('.card-color-swatch__link');
    if (!sw) {
      console.log('REAVERFIT: Pas une pastille');
      return;
    }
    
    console.log('REAVERFIT: Pastille cliquée:', sw);
    e.preventDefault(); // Empêcher la navigation
    
    // Marquer comme active
    setActive(sw);
    
    // Changer l'image pour montrer le produit lié
    const card = closestCard(sw);
    if (!card) {
      console.log('REAVERFIT: Carte non trouvée');
      return;
    }
    
    // Récupérer les images du produit lié
    const mainImageUrl = sw.getAttribute('data-image-main');
    const hoverImageUrl = sw.getAttribute('data-image-hover');
    
    console.log('REAVERFIT: URLs des images - main:', mainImageUrl, 'hover:', hoverImageUrl);
    
    // Trouver les images dans la carte
    const { mainImg, hoverImg } = findImages(card);
    
    // Mettre à jour l'image principale
    if (mainImg && mainImageUrl) {
      mainImg.src = mainImageUrl;
      mainImg.srcset = mainImageUrl;
      console.log('REAVERFIT: Image principale mise à jour vers:', mainImageUrl);
    }
    
    // Mettre à jour l'image hover
    if (hoverImg && hoverImageUrl) {
      hoverImg.src = hoverImageUrl;
      hoverImg.srcset = hoverImageUrl;
      console.log('REAVERFIT: Image hover mise à jour vers:', hoverImageUrl);
    }
    
    // Mettre à jour le titre du produit
    const productTitle = sw.getAttribute('data-product-title');
    if (productTitle) {
      const titleEl = card.querySelector('.product-title, .product-card__title, .product-card__heading, h3, h4');
      if (titleEl) {
        titleEl.textContent = productTitle;
        console.log('REAVERFIT: Titre mis à jour vers:', productTitle);
      } else {
        console.log('REAVERFIT: Élément titre non trouvé dans la carte');
        console.log('REAVERFIT: Structure de la carte pour debug:', card.innerHTML.substring(0, 1000));
      }
    } else {
      console.log('REAVERFIT: Pas de titre de produit dans les données de la swatch');
    }

    // Mettre à jour les liens pour rediriger vers le bon produit
    const targetUrl = sw.getAttribute('data-target-url');
    if (targetUrl) {
      // Mettre à jour le lien de l'image principale
      const mainImageLink = card.querySelector('.product-card__image-link, .product-card__media-link, a[href*="/products/"]');
      if (mainImageLink) {
        mainImageLink.href = targetUrl;
        console.log('REAVERFIT: Lien de l\'image mis à jour vers:', targetUrl);
      }
      
      // Mettre à jour aussi le lien du titre du produit
      const productTitleLink = card.querySelector('.product-card__title-link, .product-title a, h3 a, h4 a');
      if (productTitleLink) {
        productTitleLink.href = targetUrl;
        console.log('REAVERFIT: Lien du titre mis à jour vers:', targetUrl);
      }
    } else {
      console.log('REAVERFIT: Pas d\'URL cible dans les données de la swatch');
    }

    // Mettre à jour le variant ID dans le formulaire d'ajout au panier
    const variantId = sw.getAttribute('data-variant-id');
    if (variantId) {
      console.log('REAVERFIT: Variant ID à mettre à jour:', variantId);
      
      // Chercher tous les formulaires d'ajout au panier dans la carte
      const forms = card.querySelectorAll('form[action*="/cart/add"], product-form form, .product-form form');
      forms.forEach(form => {
        let idInput = form.querySelector('input[name="id"]');
        if (!idInput) {
          // Créer l'input s'il n'existe pas
          idInput = document.createElement('input');
          idInput.type = 'hidden';
          idInput.name = 'id';
          form.appendChild(idInput);
        }
        idInput.value = variantId;
        console.log('REAVERFIT: Variant ID mis à jour dans le formulaire:', variantId);
      });
      
      // Mettre à jour aussi les boutons d'ajout au panier avec data-variant-id
      const addToCartButtons = card.querySelectorAll('[data-variant-id], .add-to-cart-button, .product-form__submit');
      addToCartButtons.forEach(button => {
        button.setAttribute('data-variant-id', variantId);
        console.log('REAVERFIT: Bouton d\'ajout au panier mis à jour avec variant ID:', variantId);
      });
    } else {
      console.log('REAVERFIT: Pas de variant ID dans les données de la swatch');
    }

    // Mettre à jour la div size-band avec les tailles du produit sélectionné
    const productHandle = sw.getAttribute('data-product-handle');
    const selectedVariantId = sw.getAttribute('data-variant-id');
    
    if (productHandle) {
      console.log('REAVERFIT: Mise à jour de la size-band pour le produit:', productHandle);
      console.log('REAVERFIT: Variant ID de la swatch sélectionnée:', selectedVariantId);
      
      // Trouver la size-band existante
      const existingSizeBand = card.querySelector('.rf-size-band');
      if (existingSizeBand) {
        // Récupérer les variantes du produit via l'API Shopify
        fetch(`/products/${productHandle}.js`)
          .then(response => response.json())
          .then(productData => {
            console.log('REAVERFIT: Données du produit récupérées:', productData.title);
            console.log('REAVERFIT: Tous les variants:', productData.variants.map(v => `${v.title} (ID: ${v.id}, Stock: ${v.available})`));
            
            // Mettre à jour le contenu de la size-band existante avec le variant sélectionné
            updateSizeBandWithSelectedVariant(existingSizeBand, productData, selectedVariantId);
            console.log('REAVERFIT: Size-band mise à jour');
          })
          .catch(error => {
            console.error('REAVERFIT: Erreur lors de la récupération des données du produit:', error);
          });
      }
    }
  });

  // On ne met AUCUN listener "mouseenter"/"mouseover" sur les swatches.

  // Affichage simple de la size-band au hover de l'image du produit
  document.addEventListener('DOMContentLoaded', () => {
    // Attacher les event listeners sur chaque zone image
    const mediaElements = document.querySelectorAll('.product-card__media, .product-card__figure');
    
    mediaElements.forEach(mediaElement => {
      mediaElement.addEventListener('mouseenter', (e) => {
        const card = e.target.closest('.product-card');
        if (!card) return;
        
        const sizeBand = card.querySelector('.rf-size-band');
        if (sizeBand) {
          sizeBand.style.display = 'block';
          sizeBand.style.opacity = '1';
        }
      });
      
      mediaElement.addEventListener('mouseleave', (e) => {
        // Vérifier si la souris va vers la size-band
        const card = e.target.closest('.product-card');
        if (!card) return;
        
        const sizeBand = card.querySelector('.rf-size-band');
        if (sizeBand) {
          // Délai pour permettre le hover sur la size-band
          setTimeout(() => {
            const isHovering = sizeBand.matches(':hover') || card.querySelector('.rf-size-band:hover');
            if (!isHovering) {
              sizeBand.style.display = 'none';
              sizeBand.style.opacity = '0';
            }
          }, 100);
        }
      });
    });
    
    // Initialiser les size-bands pour tous les produits
    initializeAllSizeBands();
    
    // Surveiller les modals de quick buy pour les produits sans swatch
    observeQuickBuyModals();
  });

})();

// Fonction pour initialiser toutes les size-bands
function initializeAllSizeBands() {
  const productCards = document.querySelectorAll('.product-card');
  
  productCards.forEach((card) => {
    const sizeBand = card.querySelector('.rf-size-band');
    if (sizeBand) {
      // Cacher initialement pour éviter le CLS
      sizeBand.style.display = 'none';
      sizeBand.style.opacity = '0';
      
      // Récupérer le handle du produit depuis la carte
      const productHandle = card.getAttribute('handle');
      if (productHandle) {
        // Mettre à jour la size-band avec les données du produit
        fetch(`/products/${productHandle}.js`)
          .then(response => response.json())
          .then(productData => {
            updateSizeBand(sizeBand, productData);
          })
          .catch(error => {
            console.error(`REAVERFIT: Erreur pour ${productHandle}:`, error);
          });
      } else {
        // Essayer d'extraire le handle depuis le lien du produit
        const productLink = card.querySelector('a[href*="/products/"]');
        if (productLink) {
          const href = productLink.getAttribute('href');
          const handleMatch = href.match(/\/products\/([^\/\?]+)/);
          if (handleMatch) {
            const extractedHandle = handleMatch[1];
            
            fetch(`/products/${extractedHandle}.js`)
              .then(response => response.json())
              .then(productData => {
                updateSizeBand(sizeBand, productData);
              })
              .catch(error => {
                console.error(`REAVERFIT: Erreur pour ${extractedHandle}:`, error);
              });
          }
        }
      }
    }
  });
}

// Fonction pour mettre à jour les tailles dans le modal de quick buy
function updateQuickBuyModalSizes(modalElement) {
  // Vérifier si c'est un produit sans color swatch
  const colorSwatches = modalElement.querySelectorAll('.rf-qb_color-swatch, .color-swatch, [data-color]');
  
  if (colorSwatches.length === 0) {
    // Produit sans color swatch, récupérer les données du produit
    const titleElement = modalElement.querySelector('.rf-qb_title, .modal-title, h1, h2, h3');
    if (titleElement) {
      const productTitle = titleElement.textContent;
      
      // Extraire le handle depuis le titre
      const handleMatch = productTitle.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
      if (handleMatch) {
        // Récupérer les données du produit
        fetch(`/products/${handleMatch}.js`)
          .then(response => response.json())
          .then(productData => {
            // Mettre à jour les tailles dans le modal
            updateModalSizeButtons(modalElement, productData);
          })
          .catch(error => {
            console.error('REAVERFIT: Erreur lors de la récupération des données du modal:', error);
          });
      }
    }
  }
}

// Fonction pour mettre à jour les boutons de taille dans le modal
function updateModalSizeButtons(modalElement, productData) {
  const sizeButtons = modalElement.querySelectorAll('.rf-size, [data-variant-id]');
  
  sizeButtons.forEach(button => {
    const currentSize = button.textContent.trim();
    
    // Trouver la variante correspondante
    const matchingVariant = productData.variants.find(v => {
      if (v.options && v.options.length >= 2) {
        return v.options[1] === currentSize; // Taille (option 1)
      }
      return false;
    });
    
    if (matchingVariant) {
      button.setAttribute('data-variant-id', matchingVariant.id);
      
      if (matchingVariant.available) {
        button.classList.remove('rf-size--oos');
        button.classList.add('rf-size--available');
        button.removeAttribute('disabled');
        button.removeAttribute('aria-disabled');
      } else {
        button.classList.remove('rf-size--available');
        button.classList.add('rf-size--oos');
        button.setAttribute('disabled', 'true');
        button.setAttribute('aria-disabled', 'true');
      }
    }
  });
}

// Fonction pour mettre à jour la size-band avec un variant sélectionné
function updateSizeBandWithSelectedVariant(sizeBand, product, selectedVariantId) {
  console.log('REAVERFIT: Mise à jour size-band pour le produit:', product.title);
  console.log('REAVERFIT: Tous les variants disponibles:', product.variants.map(v => `${v.title} (ID: ${v.id}, Stock: ${v.available})`));
  
  // Récupérer tous les variants du produit
  const variants = product.variants;
  const sizeButtons = sizeBand.querySelectorAll('.rf-size');
  
  // Pour chaque bouton de taille existant, trouver le variant correspondant
  sizeButtons.forEach(button => {
    const currentSize = button.textContent.trim();
    console.log(`REAVERFIT: Recherche du variant pour la taille: ${currentSize}`);
    
    // Chercher le variant qui correspond à cette taille
    const matchingVariant = variants.find(variant => {
      const variantTitle = variant.title || '';
      const variantSize = variantTitle.split('/')[0]; // "XS" depuis "XS/34"
      return variantSize === currentSize;
    });
    
    if (matchingVariant) {
      button.setAttribute('data-variant-id', matchingVariant.id);
      console.log(`REAVERFIT: ✅ Variant trouvé pour ${currentSize}:`, matchingVariant.id, 'Stock:', matchingVariant.available, 'Titre:', matchingVariant.title);
      
      if (matchingVariant.available) {
        button.classList.remove('rf-size--oos');
        button.classList.add('rf-size--available');
        if (button.tagName === 'BUTTON') {
          button.removeAttribute('disabled');
        }
        button.removeAttribute('aria-disabled');
      } else {
        button.classList.remove('rf-size--available');
        button.classList.add('rf-size--oos');
        if (button.tagName === 'BUTTON') {
          button.setAttribute('disabled', 'true');
        }
        button.setAttribute('aria-disabled', 'true');
      }
    } else {
      console.log(`REAVERFIT: ❌ Aucun variant trouvé pour la taille ${currentSize}`);
      button.classList.remove('rf-size--available');
      button.classList.add('rf-size--oos');
      if (button.tagName === 'BUTTON') {
        button.setAttribute('disabled', 'true');
      }
      button.setAttribute('aria-disabled', 'true');
    }
  });
}

// Fonction pour mettre à jour la size-band (ancienne version - fallback)
function updateSizeBand(sizeBand, product) {
  const sizeButtons = sizeBand.querySelectorAll('.rf-size');
  
  // Récupérer le variant ID actuellement sélectionné dans la carte
  const card = sizeBand.closest('.product-card');
  const activeSwatch = card ? card.querySelector('.card-color-swatch__link.active') : null;
  const selectedVariantId = activeSwatch ? activeSwatch.getAttribute('data-variant-id') : null;
  
  console.log('REAVERFIT: Variant ID sélectionné:', selectedVariantId);
  
  sizeButtons.forEach(button => {
    const currentSize = button.textContent.trim();
    
    // Si on a un variant sélectionné, chercher les variants avec la même couleur
    if (selectedVariantId) {
      const selectedVariant = product.variants.find(v => v.id.toString() === selectedVariantId.toString());
      if (selectedVariant && selectedVariant.options && selectedVariant.options.length >= 2) {
        console.log('REAVERFIT: Variant sélectionné:', selectedVariant.title, 'Options:', selectedVariant.options);
        
        // Déterminer quelle option est la couleur et laquelle est la taille
        let colorOptionIndex = 0;
        let sizeOptionIndex = 1;
        
        // Si les options contiennent des tailles, ajuster les indices
        if (selectedVariant.options[0] && selectedVariant.options[0].includes('/')) {
          // La première option contient la taille (ex: "XS/34")
          sizeOptionIndex = 0;
          colorOptionIndex = 1;
        } else if (selectedVariant.options[1] && selectedVariant.options[1].includes('/')) {
          // La deuxième option contient la taille (ex: "XS/34")
          sizeOptionIndex = 1;
          colorOptionIndex = 0;
        }
        
        const selectedColor = selectedVariant.options[colorOptionIndex];
        const selectedSize = selectedVariant.options[sizeOptionIndex];
        
        console.log(`REAVERFIT: Couleur sélectionnée: ${selectedColor}, Taille sélectionnée: ${selectedSize}`);
        console.log(`REAVERFIT: Recherche pour taille ${currentSize} avec couleur ${selectedColor}`);
        
        // Chercher le variant avec la même couleur et la taille actuelle
        const matchingVariant = product.variants.find(v => {
          if (v.options && v.options.length >= 2) {
            const variantColor = v.options[colorOptionIndex];
            const variantSize = v.options[sizeOptionIndex];
            const matches = variantColor === selectedColor && variantSize === currentSize;
            console.log(`REAVERFIT: Test variant ${v.id}: ${variantColor}/${variantSize} vs ${selectedColor}/${currentSize} = ${matches}`);
            return matches;
          }
          return false;
        });
        
        if (matchingVariant) {
          button.setAttribute('data-variant-id', matchingVariant.id);
          console.log(`REAVERFIT: ✅ Variant trouvé pour ${currentSize} (couleur ${selectedColor}):`, matchingVariant.id, 'Stock:', matchingVariant.available, 'Titre:', matchingVariant.title);
          
          if (matchingVariant.available) {
            button.classList.remove('rf-size--oos');
            button.classList.add('rf-size--available');
            if (button.tagName === 'BUTTON') {
              button.removeAttribute('disabled');
            }
            button.removeAttribute('aria-disabled');
          } else {
            button.classList.remove('rf-size--available');
            button.classList.add('rf-size--oos');
            if (button.tagName === 'BUTTON') {
              button.setAttribute('disabled', 'true');
            }
            button.setAttribute('aria-disabled', 'true');
          }
        } else {
          console.log(`REAVERFIT: ❌ Aucun variant trouvé pour ${currentSize} (couleur ${selectedColor})`);
          button.classList.remove('rf-size--available');
          button.classList.add('rf-size--oos');
          if (button.tagName === 'BUTTON') {
            button.setAttribute('disabled', 'true');
          }
          button.setAttribute('aria-disabled', 'true');
        }
      }
    } else {
      // Fallback: logique originale
      const matchingVariant = product.variants.find(v => {
        if (v.options && v.options.length >= 2) {
          return v.options[1] === currentSize; // Taille (option 1)
        }
        return false;
      });
      
      if (matchingVariant) {
        button.setAttribute('data-variant-id', matchingVariant.id);
        
        if (matchingVariant.available) {
          button.classList.remove('rf-size--oos');
          button.classList.add('rf-size--available');
          if (button.tagName === 'BUTTON') {
            button.removeAttribute('disabled');
          }
          button.removeAttribute('aria-disabled');
        } else {
          button.classList.remove('rf-size--available');
          button.classList.add('rf-size--oos');
          if (button.tagName === 'BUTTON') {
            button.setAttribute('disabled', 'true');
          }
          button.setAttribute('aria-disabled', 'true');
        }
      }
    }
  });
}

// Fonction pour mettre à jour la size-band avec la couleur sélectionnée
function updateSizeBandWithColor(sizeBand, product, selectedVariantId) {
  const sizeButtons = sizeBand.querySelectorAll('.rf-size');
  
  // Trouver la variante sélectionnée pour obtenir sa couleur
  const selectedVariant = product.variants.find(v => v.id.toString() === selectedVariantId.toString());
  if (!selectedVariant) {
    console.log('REAVERFIT: Variante sélectionnée non trouvée, utilisation de la logique par défaut');
    updateSizeBand(sizeBand, product);
    return;
  }
  
  const selectedColor = selectedVariant.options[0]; // Couleur (option 0)
  console.log('REAVERFIT: Couleur sélectionnée:', selectedColor);
  console.log('REAVERFIT: Variante sélectionnée:', selectedVariant);
  
  sizeButtons.forEach(button => {
    const currentSize = button.textContent.trim();
    
    // Trouver la variante correspondante avec la couleur ET la taille
    const matchingVariant = product.variants.find(v => {
      if (v.options && v.options.length >= 2) {
        const variantColor = v.options[0]; // Couleur (option 0)
        const variantSize = v.options[1];   // Taille (option 1)
        const matches = variantColor === selectedColor && variantSize === currentSize;
        console.log(`REAVERFIT: Comparaison ${currentSize} - Variant: ${variantColor}/${variantSize}, Selected: ${selectedColor}, Match: ${matches}`);
        return matches;
      }
      return false;
    });
    
    if (matchingVariant) {
      button.setAttribute('data-variant-id', matchingVariant.id);
      console.log(`REAVERFIT: Variante trouvée pour ${currentSize} en ${selectedColor}:`, matchingVariant.id, 'Stock:', matchingVariant.available);
      
      if (matchingVariant.available) {
        button.classList.remove('rf-size--oos');
        button.classList.add('rf-size--available');
        if (button.tagName === 'BUTTON') {
          button.removeAttribute('disabled');
        }
        button.removeAttribute('aria-disabled');
      } else {
        button.classList.remove('rf-size--available');
        button.classList.add('rf-size--oos');
        if (button.tagName === 'BUTTON') {
          button.setAttribute('disabled', 'true');
        }
        button.setAttribute('aria-disabled', 'true');
      }
    } else {
      console.log(`REAVERFIT: Aucune variante trouvée pour ${currentSize} en ${selectedColor}`);
      // Marquer comme non disponible
      button.classList.remove('rf-size--available');
      button.classList.add('rf-size--oos');
      if (button.tagName === 'BUTTON') {
        button.setAttribute('disabled', 'true');
      }
      button.setAttribute('aria-disabled', 'true');
    }
  });
}

// Fonction pour surveiller les modals de quick buy
function observeQuickBuyModals() {
  // Observer les changements dans le DOM pour détecter les modals
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.classList && 
              (node.classList.contains('modal') || node.classList.contains('quick-buy-modal'))) {
            // Modal détecté, vérifier s'il faut mettre à jour les tailles
            setTimeout(() => updateQuickBuyModalSizes(node), 100);
          }
        });
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Vérifier si un modal existe déjà
  const existingModal = document.querySelector('.modal, .quick-buy-modal');
  if (existingModal) {
    setTimeout(() => updateQuickBuyModalSizes(existingModal), 100);
  }
}

// --- REAVERFIT - Mobile accordion for sidebar menu (lightweight + UX smooth) ---
document.addEventListener('DOMContentLoaded', () => {
  // Laisse tel quel si tu l'utilises ailleurs
  if (typeof observeQuickBuyModals === 'function') {
    observeQuickBuyModals();
  }

  const DEBUG = true; // passe à true si tu veux les logs
  const log = (...args) => DEBUG && console.log('[RF-ACC]', ...args);

  // Selectors utilisés par le thème
  const SIDEBAR_SELECTOR = '.header-sidebar';
  const MAIN_PANEL_SELECTOR = '.header-sidebar__main-panel';
  const BUTTON_SELECTOR = '.header-sidebar__linklist-button[aria-controls]';

  let sidebarEl = null;
  let mainPanelEl = null;
  let delegatedClickBound = false;

  // Utilitaires animation hauteur (fluide & sans reflow violent)
  const openSection = (el) => {
    if (!el) return;
    el.style.display = 'block';
    const startHeight = el.offsetHeight; // 0 si fermé
    const targetHeight = el.scrollHeight;

    // Démarre à la hauteur actuelle
    el.style.height = startHeight + 'px';
    el.classList.add('is-opening');

    // Prochaine frame: anime vers la hauteur cible
    requestAnimationFrame(() => {
      el.style.height = targetHeight + 'px';
    });

    const onEnd = (e) => {
      if (e.propertyName !== 'height') return;
      el.removeEventListener('transitionend', onEnd);
      el.classList.remove('is-opening');
      el.classList.add('is-open');
      el.style.height = 'auto'; // pour s'adapter au contenu
    };
    el.addEventListener('transitionend', onEnd);
  };

  const closeSection = (el) => {
    if (!el) return;
    const currentHeight = el.offsetHeight;
    el.style.height = currentHeight + 'px';
    el.style.display = 'block';

    // Force reflow pour que la transition parte bien de la hauteur actuelle
    // eslint-disable-next-line no-unused-expressions
    el.offsetHeight;

    el.classList.add('is-closing');
    el.classList.remove('is-open');
    el.style.height = '0px';

    const onEnd = (e) => {
      if (e.propertyName !== 'height') return;
      el.removeEventListener('transitionend', onEnd);
      el.classList.remove('is-closing');
      el.style.display = 'none';
      // Nettoyage inline minimal
    };
    el.addEventListener('transitionend', onEnd);
  };

  // Crée (une seule fois) le contenu accordéon sous un bouton
  const buildAccordionForButton = (button) => {
    const li = button.closest('li');
    if (!li) return null;

    // Déjà construit ?
    let content = li.querySelector(':scope > .accordion-content');
    if (content) return content;

    const panelId = button.getAttribute('aria-controls');
    if (!panelId) return null;

    const targetPanel = document.getElementById(panelId);
    if (!targetPanel) return null;

    // Clone léger des liens (sans listeners)
    const links = targetPanel.querySelectorAll('a');
    if (!links.length) return null;

    const frag = document.createDocumentFragment();
    links.forEach((link) => {
      const a = document.createElement('a');
      a.href = link.href;
      a.textContent = link.textContent.trim();
      if (link.className) a.className = link.className;
      a.setAttribute('role', 'link');
      frag.appendChild(a);
    });

    content = document.createElement('div');
    content.className = 'accordion-content';
    content.setAttribute('role', 'region');
    content.setAttribute('aria-hidden', 'true');
    content.style.display = 'none';
    content.style.overflow = 'hidden'; // pour l'animation hauteur
    content.style.height = '0px';

    content.appendChild(frag);
    li.appendChild(content);

    return content;
  };

  // Ferme tous les autres accordéons (one-open behavior)
  const closeOthers = (exceptBtn) => {
    const buttons = mainPanelEl.querySelectorAll(BUTTON_SELECTOR);
    buttons.forEach((btn) => {
      if (btn === exceptBtn) return;
      
      const li = btn.closest('li');
      const content = li && li.querySelector(':scope > .accordion-content');
      if (content) {
        // Vérifier si l'accordéon est ouvert de plusieurs façons
        const ariaExpanded = btn.getAttribute('aria-expanded') === 'true';
        const hasIsOpenClass = content.classList.contains('is-open');
        const isVisible = content.style.display !== 'none' && content.style.height !== '0px';
        
        if (ariaExpanded || hasIsOpenClass || isVisible) {
          log('Fermeture autre accordéon:', btn.textContent.trim());
          btn.setAttribute('aria-expanded', 'false');
          content.setAttribute('aria-hidden', 'true');
          content.classList.remove('is-open');
          closeSection(content);
        }
      }
    });
  };

  // Delegate clicks depuis le panel principal (évite N listeners)
  const bindDelegatedClick = () => {
    if (delegatedClickBound || !mainPanelEl) return;
    mainPanelEl.addEventListener(
      'click',
      (e) => {
        const button = e.target.closest(BUTTON_SELECTOR);
        if (!button) return;

        log('Clic détecté sur bouton:', button.textContent.trim());

        // Intercepter AVANT le thème
        e.preventDefault();
        e.stopPropagation();

        log('Event prévenu, defaultPrevented:', e.defaultPrevented);

        // Build à la volée si besoin
        const content = buildAccordionForButton(button);
        if (!content) {
          log('Pas de contenu trouvé pour ce bouton');
          return;
        }

        // Vérifier l'état actuel de plusieurs façons
        const ariaExpanded = button.getAttribute('aria-expanded') === 'true';
        const hasIsOpenClass = content.classList.contains('is-open');
        const isVisible = content.style.display !== 'none' && content.style.height !== '0px';
        
        const isOpen = ariaExpanded || hasIsOpenClass || isVisible;
        
        log('État accordéon - aria-expanded:', ariaExpanded, 'is-open class:', hasIsOpenClass, 'visible:', isVisible, 'final isOpen:', isOpen);

        // One-open: fermer les autres
        closeOthers(button);

        if (isOpen) {
          log('Fermeture accordéon...');
          button.setAttribute('aria-expanded', 'false');
          content.setAttribute('aria-hidden', 'true');
          content.classList.remove('is-open');
          closeSection(content);
          log('Accordéon fermé');
        } else {
          log('Ouverture accordéon...');
          button.setAttribute('aria-expanded', 'true');
          content.setAttribute('aria-hidden', 'false');
          content.classList.add('is-open');
          openSection(content);
          log('Accordéon ouvert');
        }
      },
      { capture: true, passive: false }
    );
    delegatedClickBound = true;
    log('Delegated click bound');
  };

  // Init « doux » : prépare le panel et les attributs ARIA
  const initMobileAccordion = () => {
    sidebarEl = document.querySelector(SIDEBAR_SELECTOR);
    mainPanelEl = document.querySelector(MAIN_PANEL_SELECTOR);
    if (!sidebarEl || !mainPanelEl) return;

    log('Initialisation accordéon mobile');

    // Prépare les boutons (ARIA)
    const buttons = mainPanelEl.querySelectorAll(BUTTON_SELECTOR);
    log('Boutons trouvés:', buttons.length);
    
    buttons.forEach((btn) => {
      // S'assure que ARIA est cohérent
      if (!btn.hasAttribute('aria-expanded')) {
        btn.setAttribute('aria-expanded', 'false');
      }
      // Ne construit pas ici: on build à la demande lors du 1er clic
    });

    bindDelegatedClick();
  };

  // Observe uniquement l'attribut "open" du sidebar pour réinit légère
  const observeSidebar = () => {
    const bodyObserver = new MutationObserver(() => {
      const sb = document.querySelector(SIDEBAR_SELECTOR);
      if (!sb) return;

      // On ne veut binder qu'une fois, mais on peut réinitialiser l'état ARIA si besoin
      if (sb.hasAttribute('open')) {
        log('Sidebar open → ensure accordions ready');
        initMobileAccordion();
      }
    });

    bodyObserver.observe(document.body, {
      subtree: true,
      childList: true,
    });

    // Petit plus : observer le changement d'attribut si supporté
    const sidebarAttrObserver = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === 'attributes' && m.attributeName === 'open') {
          if (sidebarEl && sidebarEl.hasAttribute('open')) {
            log('Sidebar attribute open → ready');
            initMobileAccordion();
          }
        }
      }
    });

    // Attache si déjà présent au chargement
    sidebarEl = document.querySelector(SIDEBAR_SELECTOR);
    if (sidebarEl) {
      sidebarAttrObserver.observe(sidebarEl, {
        attributes: true,
        attributeFilter: ['open'],
      });
    }
  };

  // Lancement
  initMobileAccordion();
  observeSidebar();
});